<template>
    <b-modal
        size="lg"
        v-model="itemVisible"
        @ok="handleOk"
        class="pt-8"
        body-class="p-2"
        centered
        header-class="p-0"
        footer-class="d-flex justify-content-center border-0"
        content-class="custom-model-wrap"
    >
        <template #modal-title>
            <div class="title-block text-center p-2">{{ discountTitle }}</div>
        </template>
        <template #default>
            <div class="create-item-popup">
                <b-form ref="form" @submit.stop.prevent="handleSubmit">
                    <b-row>
                        <b-col cols="12" class="mt-3">
                            <label class="mb-3">
                                <strong>{{ $translate('name') }}</strong>
                            </label>
                            <b-form-input
                                id="input-name"
                                name="input-name"
                                size="sm"
                                :placeholder="$translate('enter_name')"
                                v-model="itemModel.name"
                                :disabled="isCompleted"
                            />
                        </b-col>

                        <b-col cols="12" class="mt-3">
                            <label class="mb-3">
                                <strong>{{ $translate('description') }}</strong>
                            </label>
                            <b-form-input
                                id="input-description"
                                name="input-description"
                                size="sm"
                                :placeholder="$translate('enter_description')"
                                v-model="itemModel.description"
                                :disabled="isCompleted"
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="mt-3" cols="12" md="5">
                            <label class="mb-3"
                                ><strong>{{
                                    $translate('actual_amount')
                                }}</strong></label
                            >
                            <b-form-input
                                id="input-price"
                                name="input-price"
                                size="sm"
                                :placeholder="$translate('enter_price')"
                                type="number"
                                min="0.01"
                                max="100000"
                                v-model="itemModel.price"
                                :disabled="isCompleted"
                            />
                        </b-col>
                        <span class="mt-5 col-12 col-md-2 pt-2 text-center"
                            ><strong>OR</strong></span
                        >
                        <b-col cols="12" class="mt-3" md="5">
                            <label class="mb-3 col-12"
                                ><strong>{{
                                    $translate('percentage')
                                }}</strong></label
                            >
                            <b-input-group class="d-flex input-merge">
                                <b-input
                                    id="input-price"
                                    name="input-price"
                                    size="sm"
                                    :placeholder="$translate('enter_price')"
                                    type="number"
                                    min="0.01"
                                    max="100"
                                    v-model="percentAmt"
                                    :disabled="isCompleted"
                                />
                                <template #append>
                                    <div
                                        class="input-group-text form-control"
                                        v-html="'&#37;'"
                                    ></div>
                                </template>
                            </b-input-group>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
        </template>
        <template #modal-footer="{ ok }">
            <div class="mt-3 d-flex">
                <b-button
                    :disabled="submitting"
                    variant="info"
                    @click="itemVisible = false"
                    class="m-1"
                    size="sm"
                    >{{ $cancelLabel() }}</b-button
                >
                <b-button
                    v-if="!isCompleted"
                    :disabled="submitting"
                    variant="info"
                    class="m-1"
                    size="sm"
                    @click="ok"
                    >{{ submitTitle }}</b-button
                >
            </div>
        </template>
    </b-modal>
</template>

<script lang="js">
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

const defaultItemModel = Object.freeze({
    id: null,
    name: 'Discount',
    order_item_type_id: null,
    master_item_id: null,
    hash: null,
    description: 'Discount',
    section_from_id: null,
    section_to_id: null,
    quantity: 0,
    uom: null,
    price: 0,
    assets: [],
    task_value: null,
    task_checked: 0,
    task_notes: '',
    is_discount_item: true  //critical
})

export default {
    name: 'orders-ViewDiscount',

    mixins: [popupMixins, permissionsMixins],
    props: ['orderModel'],
    data() {
        return {
            itemVisible: false,
            submitting: false,
            itemModel: {},
            masterItem: {},
            percentAmt: 0
        }
    },

    filters: {

    },

    computed: {
        order_id() {
            return this.orderId || this.$route.params.id
        },
        submitTitle() {
            console.log('this.itemModel', this.itemModel)
            return this.adjustmentItems.length && this.submitting
                ? this.$translate('updating_discount')
                : this.adjustmentItems.length
                    ? this.$translate('update_discount')
                    : this.submitting
                        ? this.$translate('creating_discount')
                        : this.$translate('create_discount')
        },

        isCompleted() {
            return !!this.orderModel.completed
        },

        itemsTotals() {
            return this.$store.getters['orderItemStore/itemsTotals']
        },
        adjustmentTotals() {
            return this.$store.getters['orderItemStore/adjustmentTotals']
        },

        discountTitle() {
            return this.adjustmentItems.length ? this.$translate("change_discount") : this.$translate("add_discount")
        },

        adjustmentItems() {
            return this.$store.getters['orderItemStore/adjustmentItems']
        },

        itemTypes() {
            return this.$store.state.itemType.items
        },

    },
    watch: {
        percentAmt: function (val) {
            const { total } = this.itemsTotals;
            this.itemModel.price = total * val / 100
        },
        "itemModel.price"(val) {
            const { total } = this.itemsTotals;
            this.percentAmt = val * 100 / total
        },
        orderModel: {
            handler: function (val) {
                console.log('orderModel--', val)
            },
            deep: true,
        },

        'this.$store.state.masterItem': {
            handler: function (val) {
                this.masterItem = val
                console.log('masterItem', val)
            },
            deep: true,
        },
        masterItem: {
            handler: function (val) {
                if (
                    val &&
                    (this.itemModel.task_value == null ||
                        typeof this.itemModel.task_value == 'undefined')
                ) {
                    console.log('bingo------val', val)
                    console.log('bingo------item', this.itemModel)
                    this.$set(this.itemModel, 'task_value', val.default_value)
                }
            },
            deep: true,
        },
    },

    mounted() {
        this.$store.dispatch('itemType/fetchAll')
    },

    methods: {

        showItem() {
            let item = null;
            if (this.adjustmentItems.length) {
                item = this.adjustmentItems[0]
                item.price = Math.abs(this.adjustmentTotals.total);
            }
            console.log('showItem item before', item)

            this.itemVisible = true

            if (item) {
                let {
                    id,
                    name,
                    order_item_type_id,
                    master_item_id,
                    hash,
                    description,
                    section_from_id,
                    section_to_id,
                    quantity,
                    price,
                    assets,
                    uom,
                    task_value,
                    display_order,
                    task_checked,
                    task_notes,
                } = item
                this.itemModel = {
                    ...defaultItemModel,
                    id,
                    name,
                    order_item_type_id,
                    master_item_id,
                    hash,
                    description,
                    section_from_id,
                    section_to_id,
                    quantity,
                    uom,
                    price,
                    assets,
                    task_value,
                    display_order,
                    task_checked,
                    task_notes,
                }
            } else {
                this.itemModel = {
                    ...defaultItemModel,
                }
            }
            console.log('showItem after itemModel', this.itemModel)
        },

        handleOk(evt) {
            // Prevent modal from closing
            evt.preventDefault()
            // Trigger submit handler
            this.handleSubmit()
        },


        async handleSubmit() {
            // Exit when the form isn't valid
            try {
                this.submitting = true
                console.log('itemModel:', this.itemModel)

                await this.mergeItem({ ...this.itemModel })

                this.itemVisible = false
            } catch (error) {
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.submitting = false
            }
        },

        async mergeItem(item) {
            try {
                console.log('add item', item)
                this.submitting = true

                item.price = parseFloat(item.price)
                item.quantity = -1

                if (!item.price) {
                    throw new Error(this.$translate('amount_required'))
                }

                if (item.price < 0) {
                    throw new Error(this.$translate('amount_invalid'))
                }

                if (!item.name) {
                    throw new Error(this.$translate('name_required'))
                }

                const discountTypes = this.itemTypes.filter(x => x.is_discount && x.is_order_item);

               /*  if (!discountTypes.length) {
                    throw new Error(this.$translate('discount_type_created_alert'))
                } */
                //////////////////////////////
                const { tax, total } = this.itemsTotals;

                const tax_rate = 100 * tax / total;
                console.log({ total, tax, tax_rate })
                item.tax_rate = tax_rate;
                if(discountTypes.length > 0){
                    item.order_item_type_id = discountTypes[0].id
                }
                item.section_from_id = null
                item.section_to_id = null
                item.section_from_id = null
                item.section_to_id = null

                ///////delete previous discount items
                for (const disc of this.adjustmentItems) {
                    await this.$store.dispatch('orderItemStore/delete', disc.hash)
                }

                console.log("discount item:",item)

                await this.$store.dispatch('orderItemStore/merge', item)
                this.percentAmt = 0
                this.itemVisible = false
            } catch (error) {
                throw error
            } finally {
                this.submitting = false
            }
        },
    },
}
</script>
